import React from "react";
import { Box, Typography } from "@mui/material";
import GradientButton from "../../../input/GradientButton";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";

/**
 * Shown when the user has zero tasks.
 * Offers a button to navigate to the task helper / creator.
 */
const NoTasksStep = ({ onNavigateToCreate }) => {
  return (
    <Box className="task-guide-step task-guide-step--no-tasks">
      <AnimatedOrb size="medium" intensity="idle" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          It looks like you don't have any tasks yet!
        </Typography>
        <Typography
          variant="body2"
          sx={{ margin: 0, mt: 1, textAlign: "center", opacity: 0.8 }}
        >
          Let's create one to get started. Think of something you'd like to get
          done. It can be anything at all.
        </Typography>
      </SpeechBubble>

      <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
        <GradientButton text="Create task" onClick={onNavigateToCreate} />
      </Box>
    </Box>
  );
};

export default NoTasksStep;
